import { Link, useLoaderData, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../../generic-error";
import ResourceDisplay from "../../../components/resource-display";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingHeart } from "@fortawesome/free-solid-svg-icons";
import { path as Form230Path } from "../page-sustine-230/index.jsx";
import ResourceService from "../../../service/resource";

const resourceKeys = {
  pageElement: "support-index-element",
  pageTitle: "support-index-title",
  buttonsTitle: "support-index-buttons-title",
  formTitle: "support-index-230-title",
  formButton: "support-index-230-button",
  formElement: "support-index-230-element",
};

export async function loader({ request }) {
  return await new ResourceService().read.byIds(Object.values(resourceKeys));
}

export function Component() {
  const resources = useLoaderData();

  return (
    <div id="sustine">
      <div className="header-bar">
        <FontAwesomeIcon icon={faHandHoldingHeart} className="icon" />
        <ResourceDisplay
          resource={resources[resourceKeys.pageTitle]}
          wrapper="h1"
        />
      </div>
      <div className="stretcher" />
      <div className="content content-container">
        <div className="information">
          <ResourceDisplay
            resource={resources[resourceKeys.buttonsTitle]}
            wrapper="h3"
            style={{
              alignItems: "center",
            }}
          />
          <div className="buttons">
            <Link to="/donate-5" className="fill-button">
              5 RON
            </Link>
            <Link to="/donate-10" className="fill-button">
              10 RON
            </Link>
            <Link to="/donate-50" className="fill-button">
              50 RON
            </Link>
            <Link to="/donate-100" className="fill-button">
              100 RON
            </Link>
            <Link to="/donate-200" className="fill-button">
              200 RON
            </Link>
            <Link to="/donate-500" className="fill-button">
              500 RON
            </Link>
          </div>
          <hr style={{ "--color": "var(--color-fasmr-blue)" }} />
          <div className="to230container">
            <ResourceDisplay
              resource={resources[resourceKeys.formElement]}
              style={{ height: "100px" }}
            />
            <div className="information">
              <ResourceDisplay
                resource={resources[resourceKeys.formTitle]}
                wrapper="h3"
              />
              <ResourceDisplay
                resource={resources[resourceKeys.formButton]}
                className="fill-button"
                wrapper={Link}
                to={Form230Path}
              />
            </div>
          </div>
        </div>
        <ResourceDisplay
          resource={resources[resourceKeys.pageElement]}
          className="element"
        />
      </div>
      <div className="stretcher" />
    </div>
  );
}
Component.displayName = "page-sustine-index";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-sustine-index-error";
